//
// Page offres : Christophe Bernard
//

const deals = {
	init(){

		if(document.querySelector('.tpl-deals .deal')){
			this.constructor();

			const MINIMUM_CARACTERS = 50;
			const LIMIT_CARACTERS = 300;

			window.addEventListener('load', ()=> {
				this.deals.forEach( deal => {
	
					let obj = { 
						width: deal.scrollWidth, 
						height : deal.scrollHeight,
						text : this.getText( deal.querySelector('.deal_description') ),
					}

					let text = deal.querySelector('.deal_description').innerText;
					let start = text.length;
					let newText = text;

					if( obj.width < obj.height+100 && start >= MINIMUM_CARACTERS){
						newText = text.slice(0, LIMIT_CARACTERS);
						deal.querySelector('.deal_description').innerText = newText + " […]";
						start = newText.length;
					}
				});
			})
		}
	},
	
	constructor(){
		this.deals = document.querySelectorAll('.deal_content');
	},
	getText(obj){
		let text = [];

		obj.querySelectorAll('*').forEach( o => {
			text.push(o)
		})
		return text
	},
	truncate(text){
		text.slice()
	}
}

export default deals;


// WEBPACK FOOTER //
// ./src/scripts/components/deals.js